import { Directive, ViewContainerRef, ChangeDetectorRef, TemplateRef, Input, NgModule } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
function clone(value) {
    let cloned;
    if (Array.isArray(value)) {
        cloned = [...value];
    }
    else if (typeof value === 'object' && value !== null) {
        cloned = Object.assign({}, value);
    }
    else {
        cloned = value;
    }
    return cloned;
}

/**
 * Directive inspired by Netanel Basel's "DIY Sibscription Handling Directive" Medium article:
 * https://netbasal.com/diy-subscription-handling-directive-in-angular-c8f6e762697f
 */
class SubscribeContext {
    constructor() {
        this.$implicit = null;
        this.subscribe = null;
    }
}
class SubscribeDirective {
    constructor(container, cdr, template) {
        this.container = container;
        this.cdr = cdr;
        this.template = template;
        this.context = new SubscribeContext();
    }
    set subscribe(inputObs) {
        if (this.observable !== inputObs) {
            this.observable = inputObs;
            this.unsubscribe();
            this.subscription = this.observable.subscribe((value) => {
                this.context.subscribe = clone(value);
                this.cdr.markForCheck();
            });
        }
    }
    ngOnInit() {
        this.container.createEmbeddedView(this.template, this.context);
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
    unsubscribe() {
        /* tslint:disable-next-line:no-unused-expression */
        this.subscription && this.subscription.unsubscribe();
    }
}
SubscribeDirective.ɵfac = function SubscribeDirective_Factory(t) { return new (t || SubscribeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SubscribeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SubscribeDirective, selectors: [["", "subscribe", ""]], inputs: { subscribe: "subscribe" } });
SubscribeDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ChangeDetectorRef },
    { type: TemplateRef }
];
SubscribeDirective.propDecorators = {
    subscribe: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SubscribeDirective, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: '[subscribe]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.TemplateRef }]; }, { subscribe: [{
            type: Input
        }] }); })();

function StateBehavior(initialValue) {
    return function (target, key) {
        const behaviorSubjectKey = Symbol();
        const observableKey = `${key}$`;
        function getBehaviorSubject(instance) {
            if (!instance[behaviorSubjectKey]) {
                instance['values'][behaviorSubjectKey] = initialValue;
                instance[behaviorSubjectKey] = new BehaviorSubject(initialValue);
            }
            return instance[behaviorSubjectKey];
        }
        Object.defineProperty(target, observableKey, {
            enumerable: true,
            get() {
                return getBehaviorSubject(this).asObservable();
            },
        });
        return {
            enumerable: true,
            get() {
                const isUndefined = this.values[key] === undefined;
                if (isUndefined && initialValue !== undefined) {
                    this.values[key] = initialValue;
                }
                return clone(this.values[key]);
            },
            set(value) {
                this.values[key] = value;
                getBehaviorSubject(this).next(clone(value));
            },
        };
    };
}

function StateProp(initialValue) {
    return function (target, key) {
        const setKey = Symbol();
        return {
            enumerable: true,
            get() {
                if (this[setKey] === undefined && initialValue !== undefined) {
                    this[setKey] = initialValue;
                    this.values[key] = initialValue;
                }
                return clone(this[setKey]);
            },
            set(value) {
                this.values[key] = clone(value);
                this[setKey] = clone(value);
            }
        };
    };
}

function StateReplay(replayLength = 1) {
    return function (target, key) {
        const replaySubjectKey = Symbol();
        const observableKey = `${key}$`;
        function getReplaySubject(instance) {
            if (!instance[replaySubjectKey]) {
                instance[replaySubjectKey] = new ReplaySubject(replayLength);
            }
            return instance[replaySubjectKey];
        }
        Object.defineProperty(target, observableKey, {
            enumerable: true,
            get() {
                return getReplaySubject(this).asObservable();
            }
        });
        return {
            enumerable: true,
            get() {
                return clone(this.values[key]);
            },
            set(value) {
                this.values[key] = value;
                getReplaySubject(this).next(clone(value));
            }
        };
    };
}

function StateSubject() {
    return function (target, key) {
        const subjectKey = Symbol();
        const observableKey = `${key}$`;
        function getSubject(instance) {
            if (!instance[subjectKey]) {
                instance[subjectKey] = new Subject();
            }
            return instance[subjectKey];
        }
        Object.defineProperty(target, observableKey, {
            enumerable: true,
            get() {
                return getSubject(this).asObservable();
            }
        });
        return {
            enumerable: true,
            get() {
                return clone(this.values[key]);
            },
            set(value) {
                this.values[key] = value;
                getSubject(this).next(clone(value));
            },
        };
    };
}

class NgxStateModule {
}
NgxStateModule.ɵfac = function NgxStateModule_Factory(t) { return new (t || NgxStateModule)(); };
NgxStateModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxStateModule });
NgxStateModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxStateModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SubscribeDirective
                ],
                exports: [
                    SubscribeDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxStateModule, { declarations: [SubscribeDirective], exports: [SubscribeDirective] }); })();

class State {
    constructor() {
        this.values = {};
    }
    get(prop) {
        return clone(this.values[prop]);
    }
    set(prop, value) {
        this[prop] = value;
    }
}

/*
 * Public API Surface of ngx-state
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxStateModule, State, StateBehavior, StateProp, StateReplay, StateSubject, SubscribeContext, SubscribeDirective, SubscribeDirective as ɵa };

